/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { FetchAppVersion, FetchSettings, UpdateSettings } from "./settingAction";

interface SettingState {
    isMultiLanguage: boolean;
    defaultLanguage: string;
    loading: boolean;
    error: string | null;
    appversion: any
    currentVersion: string,
    forceUpdate: boolean,
    updateMessage: string
}

const initialState: SettingState = {
    isMultiLanguage: false,
    defaultLanguage: "ar",
    loading: false,
    error: null,
    appversion: {},
    currentVersion: "",
    forceUpdate: false,
    updateMessage: ''
};




const languageSlice = createSlice({
    name: "language",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(FetchSettings.pending, (state) => {
                state.loading = true;
            })
            .addCase(FetchSettings.fulfilled, (state, { payload }) => {
                state.isMultiLanguage = payload.data.isMultiLanguage;
                state.defaultLanguage = payload.data.defaultLanguage;
                state.loading = false;
            })
            .addCase(FetchSettings.rejected, (state, action) => {
                state.error = action.error.message || "Failed to fetch settings";
                state.loading = false;
            })
            .addCase(UpdateSettings.pending, (state) => {
                state.loading = true;
            })
            .addCase(UpdateSettings.fulfilled, (state, action) => {
                state.isMultiLanguage = action.payload.isMultiLanguage;
                state.defaultLanguage = action.payload.defaultLanguage;
                state.loading = false;
            })
            .addCase(UpdateSettings.rejected, (state, action) => {
                state.error = action.error.message || "Failed to update settings";
                state.loading = false;
            });
    },
});


const appVersion = createSlice({
    name: "language",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(FetchAppVersion.pending, (state) => {
                state.loading = true;
            })
            .addCase(FetchAppVersion.fulfilled, (state, { payload }) => {
                state.appversion = payload.data.data;
                state.currentVersion = payload.data.currentVersion
                state.forceUpdate = payload.data.forceUpdate
                state.updateMessage = payload.data.updateMessage
                state.loading = false;
            })
            .addCase(FetchAppVersion.rejected, (state, action) => {
                state.error = action.error.message || "Failed to fetch settings";
                state.loading = false;
            })
            .addCase(UpdateSettings.pending, (state) => {
                state.loading = true;
            })
            .addCase(UpdateSettings.fulfilled, (state, action) => {
                state.isMultiLanguage = action.payload.isMultiLanguage;
                state.defaultLanguage = action.payload.defaultLanguage;
                state.loading = false;
            })
            .addCase(UpdateSettings.rejected, (state, action) => {
                state.error = action.error.message || "Failed to update settings";
                state.loading = false;
            });
    },
});



const updateAppVersion = createSlice({
    name: "updateAppVersion",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(UpdateSettings.pending, (state) => {
                state.loading = true;
            })
            .addCase(UpdateSettings.fulfilled, (state, action) => {
                // state.isMultiLanguage = action.payload.isMultiLanguage;
                // state.defaultLanguage = action.payload.defaultLanguage;
                state.loading = false;
            })
            .addCase(UpdateSettings.rejected, (state, action) => {
                state.error = action.error.message || "Failed to update settings";
                state.loading = false;
            });
    },
});

export const languageReducer = languageSlice.reducer;
export const appVersionReducer = appVersion.reducer;
export const updateAppVersionReducer = updateAppVersion.reducer
